import React, { useState } from 'react'
import withStyles from 'constructicon/with-styles'
import styles from './styles'
import DonorAvatar from '../DonorAvatar'
import Grid from 'constructicon/grid'
import GridColumn from 'constructicon/grid-column'
import InlineButton from '../InlineButton'
import Icon from 'constructicon/icon'
import Section from '../Section'
import Status from '../Status'
import Tooltip from '../Tooltip'
import { showNumberInCurrencyCents } from '../../lib/showNumber'
import moment from 'moment'

const DonationFeed = ({
  manualDonations = [],
  child,
  classNames,
  data = [],
  onReply,
  status = 'fetching',
  styles
}) => {
  const [sortBy, setSortBy] = useState('newest')
  const [displayCount, setDisplayCount] = useState(5)

  let allDonations = [
    ...manualDonations,
    ...data
  ]

  if (sortBy === 'amount') {
    allDonations = [...allDonations].sort((a, b) => (b.amount || 0) - (a.amount || 0))
  } else {
    allDonations = [...allDonations].sort((a, b) => new Date(b.date) - new Date(a.date))
  }

  const displayedDonations = allDonations.slice(0, displayCount)
  const hasMoreToLoad = displayCount < allDonations.length

  if (!allDonations.length) {
    return (
      <Section heading='Donation Feed'>
        <Status
          empty={!allDonations.length}
          emptyMessage='You have not received your first donation'
          status={status}
        />
      </Section>
    )
  }

  return (
    <Section
      buttons={[{
        label: 'Top',
        onClick: () => setSortBy('amount')
      }, {
        label: 'Newest',
        onClick: () => setSortBy('newest')
      }]}
      heading='Donation Feed'
      noBodyPadding
    >
      <Status
        empty={!allDonations.length}
        status={status}
      >
        {displayedDonations.map(donation => (
          <div
            className={classNames.root}
            key={donation.id}
          >
            <div className={classNames.donation}>
              <Grid
                align='center'
                spacing={0.25}
              >
                <GridColumn
                  xs={2}
                  md={1}
                >
                  <DonorAvatar
                    alt={donation.name || 'Anonymous'}
                    image={donation.image}
                  />
                </GridColumn>
                <GridColumn
                  xs={4}
                  md={2}
                >
                  {donation.name || 'Anonymous'}
                </GridColumn>
                <GridColumn
                  xs={6}
                  md={3}
                  xsAlign='right'
                  mdAlign='left'
                >
                  {moment(donation.date).fromNow()}
                </GridColumn>
                <GridColumn
                  xs={8}
                  md={5}
                >
                  {donation.message}
                </GridColumn>
                <GridColumn
                  styles={styles.amount}
                  md={1}
                  xs={4}
                  xsAlign='right'
                >
                  {donation.amount
                    ? showNumberInCurrencyCents(donation.amount)
                    : (
                      <Tooltip info='The donor opted to hide the donated amount'>
                        <Icon name='info' />
                      </Tooltip>
                      )}
                </GridColumn>
              </Grid>
            </div>
            {!donation.reply && donation.id && onReply && (
              <div className={classNames.reply}>
                <InlineButton
                  icon='edit'
                  onClick={() => onReply(donation)}
                  margin={{ r: 0.5 }}
                >
                  Reply
                </InlineButton>
              </div>
            )}
            {donation.reply && (
              <div className={classNames.reply}>
                <Grid
                  align='center'
                  spacing={0.25}
                >
                  <GridColumn
                    xs={2}
                    md={1}
                  >
                    <DonorAvatar
                      alt={child.firstname}
                      image={child.image_url}
                    />
                  </GridColumn>
                  <GridColumn
                    xs={10}
                    md={11}
                  >
                    <div className={classNames.replyLabel}>
                      {`${child.firstname} replied`}
                    </div>
                    <div className={classNames.replyContent}>
                      {donation.reply}
                      {donation.id && onReply && (
                        <InlineButton
                          icon='edit'
                          onClick={() => onReply(donation)}
                        />
                      )}
                    </div>
                  </GridColumn>
                </Grid>
              </div>
            )}
          </div>
        ))}
        {hasMoreToLoad && (
          <div className={classNames.loadMoreContainer}>
            <div
              onClick={() => setDisplayCount(prev => prev + 5)}
              className={classNames.loadMoreButton}
            >
              More
            </div>
          </div>
        )}
      </Status>
    </Section>
  )
}

export default withStyles(styles)(DonationFeed)
